export const addDoubleQuotesWithValuesContainingDelimiters = (
  str: string
): string => {
  try {
    return `"${str}"`;
  } catch (error) {
    return "";
  }
};
